import {noWhitespaceValidator} from './no_whitespace.validator';

export const ValidatorsApp = {
	no_whitespace: noWhitespaceValidator()
}
